import { render, staticRenderFns } from "./NotVerifiedSoc.vue?vue&type=template&id=3fc4bd5c&scoped=true"
import script from "./NotVerifiedSoc.vue?vue&type=script&lang=js"
export * from "./NotVerifiedSoc.vue?vue&type=script&lang=js"
import style0 from "./NotVerifiedSoc.vue?vue&type=style&index=0&id=3fc4bd5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc4bd5c",
  null
  
)

export default component.exports